/* eslint-disable */
import { GetterTree } from "vuex";
import { Employment } from "@/models/employment";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { EmploymentState } from "@/types/employment";

const getters: GetterTree<EmploymentState, RootState> = {
  list: state => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: state => {
    return state.pagination || new Pagination();
  },
  single: state => {
    return state.single || new Employment();
  },
  selectItem: state => {
    return state.pagination
      ? state.pagination.data.map(employment =>
          Employment.toSelectItem(employment)
        )
      : [];
  },
  find: state => (id: number) => {
    return state.pagination
      ? state.pagination.data.find(employment => {
          return employment.id == id;
        })
      : new Employment();
  }
};

export default getters;
